import module from 'contabilidad/declaracionIsn/module'
import template from './template.html'

export class ContabilidadDeclaracionIsnGenerarLayoutComponent {
  empresaId = null
  presentacionId = null
  periodicidadId = null
  fechaInicial = null
  fechaFinal = null
  regimenFiscal = null
  estadoId = null
  procesando = false
  resultado = { descargado: false }
  onClose = undefined

  constructor(generarLayout) {
    this.generarLayout = generarLayout
  }

  descargar () {
    if (!this.resultado) return

    this.resultado.data.save()
  }

  generar () {
    this.procesando = true

    this.generarLayout.get(this.empresaId, this.presentacionId, this.periodicidadId, this.fechaInicial.toYMD(), this.fechaFinal.toYMD(), this.regimenFiscal, this.estadoId)
      .then((response) => {
        this.resultado = response
        this.resultado.descargado = true
      })
      .catch((response) => {
        this.error = response.data
        this.procesando = false
      })
  }

  cerrar () {
    this.onClose({ $event: { detail: this.resultado } })
  }
}

module.component('contabilidadDeclaracionIsnGenerarLayout', {
  controller: ContabilidadDeclaracionIsnGenerarLayoutComponent,
  template,
  bindings: {
    empresaId: '<',
    presentacionId: '<',
    periodicidadId: '<',
    fechaInicial: '<',
    fechaFinal: '<',
    regimenFiscal: '<',
    estadoId: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/contabilidad/declaracionIsn/components/generarLayout/component.js